import axios from 'axios';
import config from 'config';
import { Effects, loop } from 'redux-loop';
import toastr from "toastr"
import * as a from 'actions/livefeedapi'
import { finalize } from "actions/URLfinalizer";

const initialState = {
	apikey: "%YOUR_API_KEY%",
	generated: false,
	wrongPassword: false,
	templates: [],
	urls: [],
	isAddUserSuccess: false,
	isDeleteUserSuccess: false
};

function generateAPIKey(auth) {
	return axios.post(finalize(config.api.root + `/user/apikey`), auth)
		.then((response) => {
			return a.generateAPIKeyOk(response);
		}).catch((error) => {
			console.log(error);
			return a.generateAPIKeyFail(error);
		});
}
export default (state = initialState, action) => {
	switch (action.type) {
		case a.GENERATE_API_KEY: {
			return loop(
				Object.assign({}, state),
				Effects.promise(generateAPIKey, action.auth)
			);
		}

		case a.GENERATE_API_KEY_OK: {
			toastr.remove();
			toastr.success("API key generated !")
			return Object.assign({}, state, {
				generated: true,
				apikey: action.apikey,
				wrongPassword: false
			})
		}

		case a.GENERATE_API_KEY_FAIL: {
			toastr.remove();
			toastr.error("Wrong password !")
			return Object.assign({}, state, {
				wrongPassword: true
			})
		}

		case a.CLEAR_API_KEY: {
			return Object.assign({}, state, {
				generated: false,
				apikey: "%YOUR_API_KEY%",
				wrongPassword: false
			})
		}

		case a.RECEIVE_TEMPLATE: {
			return Object.assign({}, state, {
				templates: action.data
			})
		}

		case a.RECEIVE_LIVEFEED: {
			return Object.assign({}, state, {
				urls: action.data
			})
		}
		case a.ADD_USERS_TO_URL_STATUS: {
			return Object.assign({}, state, {
				isAddUserSuccess: action.bool
			})
		}
		case a.REMOVE_USER_FROM_URL_STATUS: {
			return Object.assign({}, state, {
				isDeleteUserSuccess: action.bool
			})
		}

		default: {
			return state
		}
	}
}


// WEBPACK FOOTER //
// ./src/reducers/livefeedapi.jsx